function avautuvaSisaltoToggle(header) {
    var panel = header.nextElementSibling;

    var plusicon = header.querySelector(".otsikko .icon-chevron-down");
    var minusicon = header.querySelector(".otsikko .icon-chevron-up");


    if (!panel.classList.contains("active")) {

        header.setAttribute("aria-expanded", "true");
        plusicon.classList.remove("show");
        plusicon.classList.add("hidden");
        minusicon.classList.remove("hidden");
        minusicon.classList.add("show");

        panel.classList.add("active");
        panel.style.height = "auto";

        var height = panel.clientHeight + "px";

        panel.style.height = "0px";

        setTimeout(function () {
            panel.style.height = height;
        }, 0);

    } else {

        header.setAttribute("aria-expanded", "false");
        plusicon.classList.remove("hidden");
        plusicon.classList.add("show");
        minusicon.classList.remove("show");
        minusicon.classList.add("hidden");

        panel.style.height = "0px";

        panel.addEventListener("transitionend", function () {
            panel.classList.remove("active");
        }, {
        once: true
        });

    }
}


var avautuvasisalto = document.getElementsByClassName("avautuvasisalto__header");
var i;

function handleClick() {
    avautuvaSisaltoToggle(this);
}

function handleKeyUp(e) {
    e.preventDefault();
    if ( e.keyCode === 13 || e.keyCode === 32 ) { //enter, space
        avautuvaSisaltoToggle(this);
    }
}

for (i = 0; i < avautuvasisalto.length; i++) {
    avautuvasisalto[i].addEventListener("click", handleClick);
    avautuvasisalto[i].addEventListener("keyup", handleKeyUp);
}

/* if (window.location.hash) {
    var targetId = window.location.hash.substring(1); // Remove the '#' character
    var targetElement = document.getElementById(targetId);
    if (targetElement && targetElement.classList.contains("avautuvasisalto")) {
        var headerWithinTarget = targetElement.querySelector('.avautuvasisalto__header');
        if (headerWithinTarget) {
            // Add a delay of 500 milliseconds (adjust as needed)
            setTimeout(function() {
                // If the target element exists and has the class "avautuvasisalto__header",
                // trigger the toggle function using the header element found within it
                avautuvaSisaltoToggle(headerWithinTarget);

                // Remove the anchor from the URL
                window.history.replaceState(null, null, window.location.pathname + window.location.search);

            }, 1000); // Adjust delay time (in milliseconds) as needed
        }
    }
} */
